import React, { useState } from 'react';
import { Navbar, Nav, Button, Offcanvas, Container } from 'react-bootstrap';
import '../styles/navbar.css'; // For additional styles

const MyNavbar = () => {

  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const handleShowOffcanvas = () => setShowOffcanvas(true);
  const handleCloseOffcanvas = () => setShowOffcanvas(false);

  return (
    <>
      <Navbar  expand="lg" sticky="top" className="navbar-custom">
        <Container fluid>
          <Navbar.Brand href="/"  >
         
         <h3 className="d-flex align-items-center fw-bold "
              style={{
                background: 'linear-gradient(90deg, #00f260, #0575E6)',
                WebkitBackgroundClip: 'text',
                color: 'transparent',
              }}>
           
            </h3>
          </Navbar.Brand>

          {/* Offcanvas trigger for small screens */}
          <Button
            variant="dark"
            className="ms-auto d-lg-none"
            onClick={handleShowOffcanvas}
          >
            Menu
          </Button>

          {/* Navbar links and buttons visible for larger screens */}
          <Navbar.Collapse id="navbarNav" className="d-none d-lg-flex justify-content-between">
           <Nav className="mx-auto">
                 <Nav.Link href="/">Home</Nav.Link>   
                <Nav.Link href="/experience">Work Experience</Nav.Link>                                   
                {/* <Nav.Link href="/projects">Projects</Nav.Link>    */}
                <Nav.Link href="/education">Education Details</Nav.Link>             
                <Nav.Link href="/skills">Technical Skills</Nav.Link>            
                <Nav.Link href="/certificates">Certifications</Nav.Link>      
                {/* <Nav.Link href="/blog">Blogs</Nav.Link>       */}
                <Nav.Link href="/about">About Me</Nav.Link>  
                </Nav>

          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Offcanvas Menu */}
      <Offcanvas
        show={showOffcanvas}
        onHide={handleCloseOffcanvas}
        placement="start"
        className="offcanvas-custom"
      >
        <Offcanvas.Header className='bg-light' closeButton>
          <Offcanvas.Title >Menu</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
        <Nav className="flex-column text-center fw-bold fs-4">
  <Nav.Link href="/" onClick={handleCloseOffcanvas}>Home</Nav.Link>
  <Nav.Link href="/experience" onClick={handleCloseOffcanvas}>Work Experience</Nav.Link>
  {/* <Nav.Link href="/projects" onClick={handleCloseOffcanvas}>Projects</Nav.Link> */}
  <Nav.Link href="/education" onClick={handleCloseOffcanvas}>Education</Nav.Link>
  <Nav.Link href="/skills" onClick={handleCloseOffcanvas}>Technical Skills</Nav.Link>
  {/* <Nav.Link href="/achievements" onClick={handleCloseOffcanvas}>Achievements</Nav.Link> */}
  <Nav.Link href="/about" onClick={handleCloseOffcanvas}>About Me</Nav.Link>

</Nav>

        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default MyNavbar;


